// Go!Bpls E2E
export const GET_TOTAL_STATS_E2E = 'CDL/get_total_stats_e2e';
export const GET_GRAPH_STATS_E2E = 'CDL/get_graph_stats_e2e';
export const GET_MAP_DATA_E2E = 'BPLS/get_map_data_e2e';
// Eboss
export const GET_TOTAL_STATS = 'CDL/get_total_stats';
export const GET_GRAPH_STATS = 'CDL/get_graph_stats';
export const GET_MAP_DATA = 'BPLS/get_map_data';

export const BPLS = [
    { name: 'NEW', color: '#5272AA', value: 0 },
    { name: 'RENEWAL', color: '#A3B3F9', value: 0 },
    { name: 'QUARTERLY', color: '#8EEED7', value: 0 },
    { name: 'DELINQUENT', color: '#87A1D1', value: 0 },
];

export const BPLS_E2E = [
    { name: 'NEW', color: '#5272AA', value: 0 },
    { name: 'RENEWAL', color: '#A3B3F9', value: 0 },
    { name: 'CHANGE', color: '#A3B3F9', value: 0 },
    { name: 'QUARTERLY', color: '#8EEED7', value: 0 },
    { name: 'DELINQUENT', color: '#87A1D1', value: 0 },
    { name: 'RETIREMENT', color: '#87A1D1', value: 0 },
];
